<script lang="ts">
  // Spacecraft type icon in the DOM (S3-20), the same shapes as the scene's sprites (textures.ts): flyby = ring with a
  // dot, orbiter = dot in a tilted orbit, probe or lander = triangle, crewed = capsule (S4-12); `silent` = outline
  // only. Decorative: the
  // surrounding control names the spacecraft and its type.
  let { type, silent = false, size = 14 }: { type: string; silent?: boolean; size?: number } = $props();

  const group = $derived(
    type === 'orbiter' || type === 'crewed'
      ? type
      : ['probe', 'lander', 'impactor', 'rover'].includes(type)
        ? 'probe'
        : 'flyby',
  );
</script>

<svg class="type-icon" width={size} height={size} viewBox="0 0 24 24" aria-hidden="true" focusable="false">
  {#if group === 'orbiter'}
    <ellipse
      cx="12"
      cy="12"
      rx="10"
      ry="5"
      transform="rotate(-28 12 12)"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
    />
    <circle cx="12" cy="12" r="3.2" fill={silent ? 'none' : 'currentColor'} stroke="currentColor" stroke-width="2" />
  {:else if group === 'crewed'}
    <path
      d="M9.4 4h5.2l5.6 11q-8.2 5 -16.4 0z"
      fill={silent ? 'none' : 'currentColor'}
      stroke="currentColor"
      stroke-width="2"
      stroke-linejoin="round"
    />
  {:else if group === 'probe'}
    <path d="M4 6h16L12 20z" fill={silent ? 'none' : 'currentColor'} stroke="currentColor" stroke-width="2" />
  {:else}
    <circle cx="12" cy="12" r="7.5" fill="none" stroke="currentColor" stroke-width="2.2" />
    {#if !silent}<circle cx="12" cy="12" r="2.8" fill="currentColor" />{/if}
  {/if}
</svg>

<style>
  .type-icon {
    display: inline-block;
    flex: none;
    vertical-align: -2px;
  }
</style>
